// React Component
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthViewComponent } from '../../components';
import { config } from '../../services/config';

const AuthView = () => {
    const navigate = useNavigate();
    const google: boolean = false;

    // Note: Removed automatic redirection to /st-portal to allow normal auth flow
    // Users will be redirected by AuthGuard if needed

    return (
        <AuthViewComponent google={google} />
    )
}
AuthView.displayName = "AuthView";
export default AuthView